<template>
    <div class="flex items-center justify-end gap-1">
        <DsIconButton
            icon="fa-regular fa-pen"
            size="sm"
            tooltipText="Edit file"
            @click="$emit('editFile', file)"
        />

        <DsMenu
            align="end"
            avoidCollisions
        >
            <template #menuTrigger>
                <DsIconButton
                    icon="fa-solid fa-ellipsis-vertical"
                    size="sm"
                    tooltipText="More actions"
                />
            </template>

            <DsMenuGroup>
                <DsMenuOption
                    :href="file.routes.details"
                    leading="fa-regular fa-eye"
                >
                    View file
                </DsMenuOption>
                <DsMenuOption
                    leading="fa-regular fa-pen"
                    @click="$emit('editFile', file)"
                >
                    Edit file
                </DsMenuOption>
                <DsMenuOption
                    leading="fa-solid fa-clock-rotate-left"
                    @click="$emit('showEventLog', file)"
                >
                    Show event log
                </DsMenuOption>
                <DsMenuOption
                    v-if="hasStreetView(file)"
                    leading="fa-regular fa-image"
                    @click="$emit('showStreetView', file)"
                >
                    Show street view
                </DsMenuOption>
            </DsMenuGroup>

            <DsMenuOption
                leading="fa-regular fa-trash-can"
                variant="destructive"
                @click="$emit('deleteFile', file)"
            >
                Delete file
            </DsMenuOption>
        </DsMenu>
    </div>
</template>

<script setup lang="ts">
import { hasStreetView } from '@/components/Views/Company/File/file-table-utils';
import type { FileTableDisplayRow } from '@/components/Views/Company/File/file-table.types';
import DsIconButton from '@ds/button/DsIconButton.vue';
import DsMenu from '@ds/menu/DsMenu.vue';
import DsMenuGroup from '@ds/menu/DsMenuGroup.vue';
import DsMenuOption from '@ds/menu/DsMenuOption.vue';

defineProps<{ file: FileTableDisplayRow }>();

defineEmits<{
    (event: 'deleteFile', file: FileTableDisplayRow): void;
    (event: 'editFile', file: FileTableDisplayRow): void;
    (event: 'showStreetView', file: FileTableDisplayRow): void;
    (event: 'showEventLog', file: FileTableDisplayRow): void;
}>();
</script>
